var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      { staticClass: "main-content" },
      [
        _c(
          "search-item",
          {
            ref: "searchItem",
            attrs: {
              "auto-init": true,
              "show-more-scheme": true,
              "show-simple": true,
              "expand-adv": true,
              "custom-search-items": _vm.customSearchItems,
              "search-item-code": _vm.$t("CargoMsg.Cargo_BusinessCommission"),
              "config-module": "506"
            },
            on: { query: _vm.queryHandler }
          },
          [
            _c(
              "template",
              { slot: "operations" },
              [
                _c("finance-btn-group", {
                  attrs: {
                    "source-view": "businessCommission",
                    job: _vm.job,
                    hp: _vm.businessCommissionHP
                  }
                })
              ],
              1
            )
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _vm.visible
              ? _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "180302",
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    }
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-end",
                  "flex-wrap": "wrap"
                }
              },
              [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showSelectionCount,
                        expression: "showSelectionCount"
                      }
                    ]
                  },
                  [_vm._v(" " + _vm._s(_vm.selectionCountLabel) + " ")]
                ),
                _vm.reCalc
                  ? _c("charge-currency-total-group", {
                      key: 1,
                      attrs: {
                        "amount-to-currency": _vm.localCurrency,
                        mode: "simple",
                        "data-field": "income",
                        type: "both",
                        "data-provider":
                          _vm.businessCommissionHP.totalGroupIncome
                            .dataProvider,
                        "currency-field": "currency",
                        "amount-to-currency-label": _vm.$t(
                          "CargoMsg.Cargo_Receivable"
                        )
                      }
                    })
                  : _vm._e(),
                _vm.reCalc
                  ? _c("charge-currency-total-group", {
                      key: 2,
                      attrs: {
                        "amount-to-currency": _vm.localCurrency,
                        mode: "simple",
                        "data-field": "cost",
                        type: "both",
                        "data-provider":
                          _vm.businessCommissionHP.totalGroupCost.dataProvider,
                        "currency-field": "currency",
                        "amount-to-currency-label": _vm.$t(
                          "CargoMsg.Cargo_Dues"
                        )
                      }
                    })
                  : _vm._e(),
                _vm.reCalc
                  ? _c("charge-currency-total-group", {
                      key: 3,
                      attrs: {
                        "amount-to-currency": _vm.localCurrency,
                        mode: "simple",
                        "data-field": "realProfit",
                        type: "both",
                        "data-provider":
                          _vm.businessCommissionHP.totalGroup.dataProvider,
                        "currency-field": "currency",
                        "amount-to-currency-label": _vm.$t(
                          "CargoMsg.Cargo_Profit"
                        )
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c("cargo-pagination", {
              attrs: {
                total: _vm.searchConditions.total,
                page: _vm.searchConditions.pageNum,
                limit: _vm.searchConditions.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageSize", $event)
                },
                pagination: _vm.queryPageHandler
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }